import { render } from "./index-promo.vue?vue&type=template&id=2e59f086"
import script from "./index-promo.vue?vue&type=script&lang=js"
export * from "./index-promo.vue?vue&type=script&lang=js"

import "./index-promo.vue?vue&type=style&index=0&id=2e59f086&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__